import styled, { createGlobalStyle } from "styled-components";
import {
  fontSizes,
  fontDefault,
  fontWeights,
  PRIMARY_COLOR,
  FONT_BODY,
  FONT_HEADER,
  FONT_HEADER_WEIGHT,
  MOBILE_BREAKPOINT,
  marginBottom,
  paddingTopBottom,
  SMALLER_MOBILE,
  FONT_PARAGRAPH,
  mediaQuery,
} from "@util/constants";

export const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0px;
    font-family: ${FONT_BODY}, sans-serif;
    font-size: ${fontDefault}px;
    font-weight: ${fontWeights.theme};
    color: ${PRIMARY_COLOR};
    line-height: 1.6;
  }

  p {
    margin: 0px;
    font-family: ${FONT_PARAGRAPH}, sans-serif;
    font-size: ${fontDefault}px;
    font-weight: ${fontWeights.theme};
    color: ${PRIMARY_COLOR};
    line-height: 1.6;    
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  body,
  input,
  textarea,
  button,
  select {
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
  }

  em {
    font-style: italic;
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sup {
    top: -0.5em;
  }

  sub {
    bottom: -0.25em;
  }

  img {
    max-width: 100%;
    border: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }

  input,
  textarea,
  button,
  select,
  a, img, div {
      -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  button,
  html input {
    &[disabled] {
      cursor: default;
    }
  }

  input {
    &[type="search"],
    &[type="number"],
    &[type="email"],
    &[type="password"] {
      -webkit-appearance: none;
      -moz-appearance: none;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }

  td,
  th {
    padding: 0;
  }

  textarea {
    overflow: auto;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${FONT_HEADER}, sans-serif;
    font-weight: ${FONT_HEADER_WEIGHT};
    line-height: 1.1;
    overflow-wrap: break-word;
    word-wrap: break-word;
    margin:0;
    font-weight:${fontWeights.theme} ;
    a {
      color: inherit;
      text-decoration: none;
      font-weight: inherit;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: 0.3s ease all;

    &:visited {
      /* color: currentColor; */
    }

  }

  p,ul{
    margin:0;
    padding:0;
  }

  span{
    line-height:1em;
  }

  section{
    width:100%;
  }

  h1 {
    font-size: ${fontSizes.h1.default}px;
  }

  h2 {
    font-size: ${fontSizes.h2.default}px;
  }
  h3 {
    font-size: ${fontSizes.h3.default}px;
  }

  .mb-none{
    ${marginBottom.none}
  }
  .mb-tiny{
    ${marginBottom.tiny}
  }
  .mb-xxs{
    ${marginBottom.xxs}
  }
  .mb-xs{
    ${marginBottom.xs}
  }
  .mb-s{
    ${marginBottom.s}
  }
  .mb-m{
    ${marginBottom.m}
  }
  .mb-l{
    ${marginBottom.l}
  }
  .mb-xl{
    ${marginBottom.xl}
  }
  .mb-xxl{
    ${marginBottom.xxl}
  }

  .ptb-none{
    ${paddingTopBottom.none}
  }
  .ptb-tiny{
    ${paddingTopBottom.tiny}
  }
  .ptb-xxs{
    ${paddingTopBottom.xxs}
  }
  .ptb-xs{
    ${paddingTopBottom.xs}
  }
  .ptb-s{
    ${paddingTopBottom.s}
  }
  .ptb-m{
    ${paddingTopBottom.m}
  }
  .ptb-l{
    ${paddingTopBottom.l}
  }
  .ptb-xl{
    ${paddingTopBottom.xl}
  }
  .ptb-xxl{
    ${paddingTopBottom.xxl}
  }

  
  .full-page-scroll {
    scroll-snap-destination: 0 0;
    overflow: hidden;
    height: 100vh;
    max-height: 100vh;
    overflow-y: scroll;
    scroll-behavior: smooth;
    scroll-snap-type: y mandatory;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: #eee;
  }
  ::-webkit-scrollbar-thumb {
    background: #ccc;
  }

  .snap-align-start {
    scroll-snap-align: start;
  }

  section:nth-of-type(2) {
    padding-top: 25px;
  }
  

  html:has(.model-open){
    max-height:100vh; 
    overflow:hidden;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    body {
      font-size: ${fontSizes.p.mobile}px;
    }

    h1 {
      font-size: ${fontSizes.h1.mobile}px;
    }
    h2 {
      font-size: ${fontSizes.h2.mobile}px;
    }
    h3 {
      font-size: ${fontSizes.h3.mobile}px;
    }
  }
  
  @media only screen and (max-width: ${SMALLER_MOBILE}px) {
    footer .footer-container {
      height: auto;
      align-items: center;
    }
  }

  @media only screen and (max-height: 667px) and (max-width: 380px) {
    footer .footer-container {
      height: auto;
    }
  }
  @media only screen and (max-height: 600px) and (max-width: 380px) {
    footer .footer-container {
      height: auto;
    }
  }
.arrow-link {
  display: flex;
  position: relative;
}

.small-arrow {
  width: 1rem;
  height: 0.65rem;
  background-size: contain;
  transition: transform 0.6s;
  display: inline-block;
}

.small-arrow--hover {
  transform: translateX(-140%);
  position: absolute;
  right: calc(100% + 1rem);
  margin-right: 0.8rem;
}
.arrow-link-text {
  font-family: ${FONT_PARAGRAPH};
  font-weight: 300;
}
.small-arrow--default {
  margin-left: 44px;
  transition-delay: 0.2s;
  margin-top: 1px;
}

.arrow-link--black .small-arrow {
  filter: brightness(0);
}

.arrow-wrapper {
  transition: transform 0.6s;
}

.arrow-link:hover .arrow-wrapper {
  transform: translateX(45px);
  transition-delay: 0.1s;
}

.arrow-link:hover .small-arrow--default {
  transform: translateX(321%);
  transition-delay: 0s;
}

.arrow-link:hover .small-arrow--hover {
  transform: translateX(12px);
  transition-delay: 0.2s;
}

.empty-speacing-div {
  margin-top:10vh;
}
 
.product-recall-btn {
  display: inline-block !important;
  margin-right: 20px;
}

.region-dropdown {
  @media only screen and (max-width: 576px) {
    display:flex;
    align-items:center;
  }
}
.gdpr-img-logo {
  width: 80%;
  margin: 20px auto;
  
  ${mediaQuery.largeDown} {
    width: 100%;
  }
}
.privacy-page-logo {
  width: 140px;
  height: 70px;
}

.privacy-title-disc {
  list-style-type: disc;
  padding-left: 30px !important;

} li::marker {
  color: black;
}
.loc-blaster-video {
  min-height: 100vh;
  max-height: 100vh;
  position: relative;
} video {
  width: 100vw;
    height: 56.25vw;
    min-height: 100vh;
    min-width: 250vh;
    border: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.custom-wtb-button{
  margin-top:15px;
}
.custom-wtb-button .bGTyUv{
  border-width: 1px;
  border-radius: 100em;
  border-style: solid;
  text-decoration: none;
  border-color: black;
  color: black;
  padding: 16px 40px 16px 20px;
  display: inline-block;
  position: relative;
  height: 100%;
}
.custom-wtb-button .bGTyUv span:first-child {
  display: block;
}
.custom-wtb-button .bGTyUv span:last-child {
  position: absolute;
  height: 100%;
  top: 0px;
  right: 15px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}

.hero-mobile-video {
 @media only screen and (max-width: 768px) {
  height:calc(100vh - 38px);
  height:calc(100svh - 38px);
  }
}
.product-carousel-order {
  .order-1 {
    order:1;
  }
  .order-2 {
    order:2;
  }
  .order-3 {
    order:3;
  }
}
.pt-0 {
  padding-top:0px !important;
}
`;

export const Main = styled.main<{}>``;
